import Reflux from 'reflux-react-16'
import socket from '../socketio/socketio.js'
import UtilActions from '../actions/UtilActions.js'

export default class UtilStore extends Reflux.Store {
    constructor() {
        super()

        this.listenables = UtilActions
    }

    onVerifySMTP(settings, callback) {
        socket.emit('verifySMTP', settings, callback)
    }

    onSendEmailPreview(...args) {
        socket.emit('sendEmailPreview', sessionStorage.token, ...args)
    }

    onTrackTrace(trackTrace, addressIndex, callback) {
        socket.emit('orders.trackTrace', trackTrace, addressIndex, callback)
    }

    onSendErrorEmail(email, message, error, callback) {
        socket.emit('mail.sendErrorEmail', sessionStorage.token || localStorage.mtoken, email, message, error, callback)
    }
}
